import { api } from "./urlApi";

export const getCargos = async () => {
  const url = `${api}/cargos/get.php`;

  try {
    const resp = await fetch(url);
    const cargos = await resp.json();
    return cargos;
  } catch (error) {
    console.error(error);
    return false;
  }
};
